// extracted by mini-css-extract-plugin
module.exports = {"container":"WeekStartingInput_container__2FGc7","dayIcon":"WeekStartingInput_dayIcon__3oOXC"};